module.exports = __webpack_public_path__ + "media/images/archi-14-5743bb96.png";